import { connect } from 'react-redux';
import React, { PropTypes } from 'react';
import { Form } from 'semantic-ui-react';
import { fetchRequirements } from '../actions/requirements';
import General from './General';
import Invoicing from './Invoicing';
import { updateData } from '../actions/form';

const mapStateToProps = (state, ownProps) => ({});

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchRequirements: () => dispatch(fetchRequirements(ownProps.id)),
  updateInvoicingIfExisting: value =>
    dispatch(updateData('invoicingInformations.invoicing', value)),
});

export class Page extends React.Component {
  componentWillMount() {
    this.props.fetchRequirements();
    if (this.props.isExisting) {
      // existing case can't select invoicing
      this.props.updateInvoicingIfExisting(false);
    }
  }

  render() {
    return (
      <Form>
        <General
          id={this.props.id}
          isExisting={this.props.isExisting}
          contractId={this.props.contractId}
          customerId={this.props.customerId}
        />
        {!this.props.isExisting && (
          <Invoicing
            id={this.props.id}
            isExisting={this.props.isExisting}
            contractId={this.props.contractId}
          />
        )}
      </Form>
    );
  }
}

Page.propTypes = {
  id: PropTypes.number.isRequired,
  customerId: PropTypes.number.isRequired,
  fetchRequirements: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Page);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-contract/organize/components/Page.js